/* RESPONSIBLE TEAM: team-workflows */
import ContentEditorRoute from 'embercom/routes/apps/app/content/edit';
import { objectTypes } from 'embercom/models/data/matching-system/matching-constants';
import { inject as service } from '@ember/service';
import { OUTBOUND_BOT_TYPE } from 'embercom/lib/operator/custom-bots/constants';
import { action } from '@ember/object';
import { get } from 'embercom/lib/ajax';

export default class AppsAppContentEditRoute extends ContentEditorRoute {
  @service appService;
  @service navbarCollapsingService;
  @service router;
  @service workflowConnectorInsertableActions;
  @service aiAgentSetupService;
  @service('workflow-editor-service') workflowEditorService;
  @service aiContentSegmentsService;

  titleToken(model) {
    let workflowTitle = model?.clientData?.title;
    if (workflowTitle) {
      return workflowTitle;
    }
    return null;
  }

  async model(params) {
    await this.workflowConnectorInsertableActions.loadActions();
    if (
      this.appService.app?.canUseFeature('team-ai-agent-guidance-applied-predicate') ||
      this.appService.app?.canUseFeature('fin-first-new-fin-step')
    ) {
      await this.store.findAll('ai-agent/guidelines');
      await this.store.findAll('ai-agent/escalation-rule');
    }
    if (this.appService.app?.canUseFeature('workflows-audience-branching')) {
      this.aiContentSegmentsService.loadSegments().catch(() => {});
    }
    return super.model(params);
  }

  async afterModel(model) {
    if (
      this.appService.app?.canUseFinProcedures &&
      model.rulesetLinks.firstObject?.object?.botData?.isProcedure
    ) {
      if (model.id) {
        try {
          let response = await get('/ember/procedures', {
            app_id: this.appService.app.id,
            ruleset_id: model.id,
          });
          this.router.transitionTo(
            'apps.app.automation.fin-ai-agent.procedures.procedure',
            response.id,
          );
          return;
        } catch (e) {
          // If lookup fails (e.g., not a valid procedure), fall through to original behavior
        }
      }
    }
    if (model.rulesetLinks.firstObject.object.type === OUTBOUND_BOT_TYPE) {
      this.outboundHomeService.setActiveList(objectTypes.customBot);
    }
    super.afterModel(...arguments);
  }

  activate() {
    super.activate(...arguments);
  }

  deactivate() {
    super.deactivate(...arguments);
    if (this.navbarCollapsingService.collapsed !== false) {
      this.navbarCollapsingService.set('collapsed', false);
    }
  }

  setupController(controller, model) {
    super.setupController(...arguments);

    this.controllerFor('apps.app.automation').set(
      'currentViewedCustomBotTarget',
      model.rulesetLinks.firstObject.object.target,
    );
    model.rulesetLinks.firstObject.object.resetInvalidActions();
    this.controllerFor('apps.app.automation.workflows').set('hidePaywallBanner', true);
    controller.set('onActivate', this.maybeReloadFinWorkflowCount);
    controller.set('onDeactivate', this.maybeReloadFinWorkflowCount);
    controller.set('onDelete', this.maybeReloadFinWorkflowCount);

    let stepId = controller.step_id;
    if (stepId) {
      this.workflowEditorService.pendingStepId = stepId;
    }
  }

  @action
  async maybeReloadFinWorkflowCount() {
    await this.aiAgentSetupService.reloadFinWorkflowsCount();
  }

  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.set('step_id', null);
    }

    this.controllerFor('apps.app.automation').set('currentViewedCustomBotTarget', undefined);
    this.controllerFor('apps.app.automation.workflows').set('hidePaywallBanner', false);
  }
}
